import { Injectable } from '@angular/core';
import { AuthenticatedHttpService } from './authenticatedhttp.service';
import { ExpressPrice } from '../model/truexpress';
import { Observable } from 'rxjs';
import { Retailer } from '../model/retailer';
import { trim } from 'lodash';

@Injectable()
export class TruExpressService {
    private baseUrl;
    private _truexpressCache: ExpressPrice;

    constructor(
        private _http: AuthenticatedHttpService
    ) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }
   
    getTruExpressPricing(retailerNumber: string): Observable<ExpressPrice[]> {

        return this._http.get(this.baseUrl + `/api/TruExpress/` + retailerNumber)
            .map(x => {
                let truExp = (<Array<ExpressPrice>>x.json());
                return truExp;
            })
            .catch(this._http.handleError);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/truexpress.service.ts